var _rect, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 54,
    viewBox: "0 0 20 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 53,
    rx: 9.5,
    fill: "currentFill",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 20.5,
    x2: 7.5,
    y2: 33.5,
    stroke: "currentStroke",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 20.5,
    x2: 12.5,
    y2: 33.5,
    stroke: "currentStroke",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderIcon);
export default __webpack_public_path__ + "static/media/sliderIcon.e8adbc281383b817796a56952372a439.svg";
export { ForwardRef as ReactComponent };